import { render, staticRenderFns } from "./EnvelopesAdd.vue?vue&type=template&id=36415cd9&"
import script from "./EnvelopesAdd.vue?vue&type=script&lang=js&"
export * from "./EnvelopesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EnvelopesAdd.vue"
export default component.exports